export default "__VITE_ASSET__Dhb0v1XG__"